// App.js - WEB
import React, {PureComponent} from "react";
import {View, Text, Platform} from "react-native";
import {connect,} from "react-redux";
//import RouterSatia from "./satia/RouterSatia";

// import {typeExport} from "../redux/store/type";
//import _G from "../tools/constant/_G";
import {moderateScale} from "../tools/Scaling";
import * as Colors from "../tools/Colors";
import store, {changeShowInstallPwa} from "../redux/store";
//import HMLoading from "../customviews/HMLoading";

// const possiblePaths = {
//     BaseToast: Platform.OS === "web" ? React.lazy(() => import("../customviews/toast/components/base")) : require("../customviews/toast/components/base").default,
//     AddToHomeScreen: Platform.OS === "web" ? React.lazy(() => import("../importCalss/AddToHomeScreen")) : require("../importCalss/AddToHomeScreen").default,
//     Toast: Platform.OS === "web" ? React.lazy(() => import("../customviews/toast")) : require("../customviews/toast").default,
// }
// const BaseToast = getNameComponent("BaseToast");
// const AddToHomeScreen = getNameComponent("AddToHomeScreen");
// const Toast = getNameComponent("Toast");

// function getNameComponent(type) {
//     return possiblePaths[type]
// }


import Toast, {BaseToast} from "../customviews/toast";
import AddToHomeScreen from "../importCalss/AddToHomeScreen";
import Router137 from './137/Router137';
// import Router1888 from './1888/Router1888';


// import RouterOperationSatia from "./satia/RouterOperationSatia";
// import Router137 from "./137/Router137";
// import RouterSatia from "./satia/RouterSatia";
// import Router125 from "./125/Router125";

//
// export const arrExport = [
//     ['Router', f()],
// ];
//
//
// function f() {
//     switch (typeExport._TypeApp) {
//         case"Satia":
//             if (typeExport._NameApp === "SatiaOperator")
//                 return "RouterOperationSatia";
//             else
//                 return "RouterSatia";
//
//         case"125":
//             return "Router125";
//
//         default:
//             return "Router137";
//
//
//     }
// }
//import AddToHomeScreen from "../tools/addToHome/AddToHomeScreen";
const toastConfig = {
    /*
      overwrite 'success' type,
      modifying the existing `BaseToast` component
    */
    custom_success: (props) => (
        <BaseToast
            {...props}
            style={{borderLeftColor: Colors.green}}
            text1Style={{
                fontSize: moderateScale(15)
            }}
            text2Style={{
                fontSize: moderateScale(14)
            }}
        />
    ),
    custom_info: (props) => (
        <BaseToast
            {...props}
            style={{borderLeftColor: "#00abdd"}}
            text1Style={{
                fontSize: moderateScale(15)
            }}
            text2Style={{
                fontSize: moderateScale(14)
            }}
        />
    ),
    custom_error: (props) => (
        <BaseToast
            {...props}
            style={{borderLeftColor: 'red'}}
            text1Style={{
                fontSize: moderateScale(15)
            }}
            text2Style={{
                fontSize: moderateScale(14)
            }}
        />
    ),
    success: ({text1, props, ...rest}) => (
        <BaseToast
            {...rest}
            //  style={{borderLeftColor: 'pink'}}
            //contentContainerStyle={{paddingHorizontal: 15}}
            text1Style={{
                fontSize: moderateScale(40),
                //   fontWeight: '400'
            }}
            // text1={text1}
            // text2={props.uuid}
        />
    ),

    /*
      or create a completely new type - `my_custom_type`,
      building the layout from scratch
    */
    my_custom_type: ({text1, props, ...rest}) => (
        <View style={{height: moderateScale(60), width: '100%', backgroundColor: 'tomato'}}>
            <Text>{text1}</Text>
        </View>
    ),

};

class Router extends PureComponent {
    constructor(props) {
        super(props);
        // if (Platform.OS === "web") {
        //     AddToHomeScreen = require("../tools/addToHome/AddToHomeScreen").default
        // }
    }

    async componentWillMount() {
        if (Platform.OS === "web") {
            let noShowInstallPwa = window.localStorage.getItem("noShowInstallPwa");
            //_G.noShowInstallPwa=window.localStorage.getItem("noShowInstallPwa");
            store.dispatch(changeShowInstallPwa(noShowInstallPwa));

            // AddToHomeScreen=noShowInstallPwa?noShowInstallPwa:AddToHomeScreen;
        }
    }

    render() {
        let {ColorsProps} = this.props.DataSplashScreen;
        let {colorPrimary, colorPrimaryDark, colorSecondPrimary, backgroundColor, blackLight} = ColorsProps ? ColorsProps : {};
        if (colorPrimary) {
           // console.log("colorPrimary@@@", ColorsProps)

            ColorsProps.colorPrimary = colorPrimary;
            ColorsProps.colorPrimaryDark = colorPrimaryDark;
            ColorsProps.colorSecondPrimary = colorSecondPrimary;
            ColorsProps.backgroundColor = backgroundColor;
            ColorsProps.blackLight = blackLight;
           // console.log("colorPrimary@@@1", ColorsProps.colorPrimary)

        }


        return (

            <View style={[{
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
            }]}>

                {
                    this.SwitchRouter()
                }
                {/*<Router125/>*/}
                <Toast
                    config={toastConfig}
                   // ref={(ref) => Toast.setRef(ref)}
                />


                {
                    AddToHomeScreen ?
                        <AddToHomeScreen
                            appId='Add-to-Homescreen React Modified Styling Example'
                            /*           customPromptContent={{
                                           cancelMsg: '',
                                           installMsg: 'Install',
                                           guidanceCancelMsg: ''
                                       }}
                                       customPromptElements={{
                                           container: 'athContainer',
                                           containerAddOns: '',
                                           banner: 'athBanner',
                                           logoCell: 'athLogoCell',
                                           logoCellAddOns: 'athContentCell',
                                           logo: 'athLogo',
                                           titleCell: 'athTitleCell',
                                           titleCellAddOns: 'athContentCell',
                                           title: 'athTitle',
                                           cancelButtonCell: 'athCancelButtonCell',
                                           cancelButtonCellAddOns: 'athButtonCell',
                                           cancelButton: 'athCancelButton',
                                           installButtonCell: 'athInstallButtonCell',
                                           installButtonCellAddOns: 'athButtonCell',
                                           installButton: 'athInstallButton',
                                           installButtonAddOns: 'button',
                                           guidance: 'athGuidance',
                                           guidanceImageCell: 'athGuidanceImageCell',
                                           guidanceImageCellAddOns: '',
                                           guidanceCancelButton: 'athGuidanceCancelButton'
                                       }}*/

                        />
                        :
                        null
                }

            </View>
        );
    }

    SwitchRouter() {
       return <Router137/>;
       //  return <Router1888/>;
       /* switch (typeExport._TypeApp) {
            case"Satia":
                //      import RouterOperationSatia from "./satia/RouterOperationSatia";
// import Router137 from "./137/Router137";
// import RouterSatia from "./satia/RouterSatia";
// import Router125 from "./125/Router125";
                if (typeExport._NameApp === "SatiaOperator") {
                    let RouterOperationSatia = require("./satia/RouterOperationSatia").default;
                    return <RouterOperationSatia/>;

                }
                else if (typeExport._NameApp === "SatiaHotspot") {
                    // let RouterHotspotSatia = require("./satia/RouterHotspotSatia").default;
                    // return <RouterHotspotSatia/>;

                }
                else {
                    let RouterSatia = require("./satia/RouterSatia").default;

                    return <RouterSatia/>;

                }

            case"125":
                let Router125 = require("./125/Router125").default;

                return <Router125/>;

            default:

                if (typeExport._NameApp === "MahalemaArak") {
                    let RouterMahalema = require("./mahalema/RouterMahalema").default;
                    return <RouterMahalema/>;

                }
                else {
                    let Router137 = require("./137/Router137").default;
                    return <Router137/>;

                }


        }*/
    }
}

const mapStateToProps = state => ({
    noShowInstallPwa: false,
    DataSplashScreen: state.reducerSplashGetAllData,

});

export default connect(
    mapStateToProps,
    {}
)(Router);
